/* ============================================================
   wishlist.js — Custom-Merkliste (localStorage) als Cart-artiges Drawer/Popup
   ------------------------------------------------------------
   Gelockte Entscheidung: Custom-Build (kein App), umfasst Produkte
   + Artikel-Bookmarks. Cross-Device-Sync über Customer-Metafield = WP 6.

   UI = sections/wishlist-drawer.liquid (global via footer-group), gespiegelt
   am Cart-Drawer; geöffnet/fokus-getrapt/Esc über window.Homedia.overlay.
   Add-to-Cart läuft über den kanonischen Controller window.Homedia.cart
   (nativer Ajax-Cart). Per-Item-Add bleibt in der Merkliste (silent), nur
   „Alle in den Warenkorb" übergibt an den Cart-Drawer.

   Datenmodell (localStorage 'hm-wishlist'): Array, neueste zuerst:
     { key, type, title, url, image, price, priceCents, brand, variant }
   - key   = product.id  ODER  'article-<id>'  (= data-wishlist-toggle)
   - variant/price/priceCents/brand nur bei type='product'
   - Snapshot beim Hinzufügen aus den data-wishlist-* des Buttons.

   Hooks:
   - [data-wishlist-toggle="<key>"]  Herz/Bookmark-Button (toggle) + Drawer-Remove-X
   - [data-wishlist-open]            Header-/Mobile-Trigger (öffnet Drawer)
   - [data-wishlist-count]           Badge (Gesamtanzahl, hidden bei 0)
   - [data-wishlist-lines]           Listen-Container im Drawer (JS-gerendert)
   - [data-wishlist-empty]           Empty-State im Drawer
   - [data-wishlist-foot]            Footer (Gesamtwert + Alle-in-Warenkorb)
   - [data-wishlist-subcount]        Untertitel im Header (Anzahl-Label)
   - [data-wishlist-total]           Gesamtwert-Betrag
   - [data-wishlist-add-all]         „Alle in den Warenkorb"
   - [data-wish-add="<variant>"]     Per-Item Add-to-Cart (im Drawer)
   - [data-wish-show-cart]           „Im Warenkorb anzeigen": schließt die Merkliste,
                                     öffnet den Cart-Drawer (Produkt liegt bereits im Cart)
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'hm-wishlist';
  var PANEL_ID = 'wishlist-drawer';
  var H = (window.Homedia = window.Homedia || {});

  /* ---------------- Storage ---------------- */
  function read() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (it) { return (typeof it === 'string') ? { key: it } : it; })
      .filter(function (it) { return it && it.key; });
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function indexOfKey(list, key) {
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) return i; }
    return -1;
  }

  /* ---------------- Snapshot aus Button ---------------- */
  function snapshot(btn, key) {
    var type = btn.getAttribute('data-wishlist-type') ||
               (key.indexOf('article-') === 0 ? 'article' : 'product');
    return {
      key: key,
      type: type,
      title: btn.getAttribute('data-wishlist-title') || '',
      url: btn.getAttribute('data-wishlist-url') || '',
      image: btn.getAttribute('data-wishlist-image') || '',
      price: btn.getAttribute('data-wishlist-price') || '',
      priceCents: parseInt(btn.getAttribute('data-wishlist-price-cents'), 10) || 0,
      brand: btn.getAttribute('data-wishlist-brand') || '',
      variant: btn.getAttribute('data-wishlist-variant') || ''
    };
  }

  /* ---------------- Sichtbaren Zustand spiegeln (Herzen + Badge) ---------------- */
  function reflect(list) {
    list = list || read();
    var n = list.length;
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', indexOfKey(list, btn.getAttribute('data-wishlist-toggle')) !== -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---------------- Toggle (Herz an/aus) ---------------- */
  function toggle(btn) {
    var key = btn.getAttribute('data-wishlist-toggle');
    if (!key) return;
    var list = read();
    var idx = indexOfKey(list, key);
    var added;
    if (idx === -1) { list.unshift(snapshot(btn, key)); added = true; }
    else { list.splice(idx, 1); added = false; }
    write(list);
    reflect(list);
    renderDrawer(list);
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: { key: key, added: added, count: list.length }
    }));
    publish('homedia:wishlist_toggle', { key: key, added: added, type: btn.getAttribute('data-wishlist-type') || '' });
  }

  function publish(name, detail) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, detail);
      }
    } catch (e) {}
  }

  /* ---------------- In-Cart-Status (für „Im Warenkorb") ---------------- */
  function cartVariantSet() {
    var set = {};
    var st = H.cart && H.cart.getState && H.cart.getState();
    if (st && st.items) {
      st.items.forEach(function (li) { set[String(li.variant_id || li.id)] = true; });
    }
    return set;
  }
  function money(cents) {
    if (H.cart && H.cart.formatMoney) return H.cart.formatMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------------- SVG-Icons (statisch, currentColor) ---------------- */
  var SVG = {
    x: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    cart: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/><path d="M2 3h2.3l2 12.2a1.5 1.5 0 0 0 1.5 1.3h8.6a1.5 1.5 0 0 0 1.5-1.2L21 7H5.4"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
  };

  /* ---------------- Drawer-Labels (i18n via data-* am Panel) ---------------- */
  function labels(panel) {
    function a(name, fb) { var v = panel.getAttribute(name); return v == null ? fb : v; }
    return {
      add: a('data-wl-add', 'In den Warenkorb'),
      inCart: a('data-wl-incart', 'Im Warenkorb anzeigen'),
      remove: a('data-wl-remove', 'Von Merkliste entfernen'),
      productOne: a('data-wl-product-one', 'Produkt'),
      productMany: a('data-wl-product-many', 'Produkte'),
      articleOne: a('data-wl-article-one', 'Artikel'),
      articleMany: a('data-wl-article-many', 'Artikel'),
      magazin: a('data-wl-magazin', 'Magazin'),
      empty: a('data-wl-empty', 'Noch nichts gemerkt')
    };
  }

  /* ---------------- Eine Zeile bauen (DOM, XSS-sicher) ---------------- */
  function buildRow(it, lab, inCart) {
    var isArticle = it.type === 'article';
    var li = document.createElement('li');
    li.className = 'hm-wish__item' + (isArticle ? ' hm-wish__item--article' : '');
    li.setAttribute('data-wish-key', it.key);

    // Media (klickt zum Ziel)
    var media = document.createElement('a');
    media.className = 'hm-wish__media';
    media.href = it.url || '#';
    if (it.image) {
      var img = document.createElement('img');
      img.src = it.image; img.alt = it.title || ''; img.loading = 'lazy'; img.decoding = 'async';
      media.appendChild(img);
    } else {
      media.className += ' hm-wish__media--empty';
    }
    li.appendChild(media);

    var body = document.createElement('div');
    body.className = 'hm-wish__body';

    // Top: Titel/Marke (Link) + Remove-X
    var top = document.createElement('div');
    top.className = 'hm-wish__top';

    var info = document.createElement('a');
    info.className = 'hm-wish__info';
    info.href = it.url || '#';
    var name = document.createElement('span');
    name.className = 'hm-wish__name';
    name.textContent = it.title || it.key;
    info.appendChild(name);
    var sub = document.createElement('span');
    sub.className = 'hm-wish__brand';
    sub.textContent = isArticle ? lab.magazin : (it.brand || '');
    if (sub.textContent) info.appendChild(sub);
    top.appendChild(info);

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'hm-wish__remove';
    rm.setAttribute('data-wishlist-toggle', it.key);
    rm.setAttribute('aria-pressed', 'true');
    rm.setAttribute('aria-label', lab.remove);
    rm.title = lab.remove;
    rm.innerHTML = SVG.x;
    top.appendChild(rm);
    body.appendChild(top);

    // Bottom: Preis + Add-to-Cart (nur Produkte)
    if (!isArticle) {
      var bottom = document.createElement('div');
      bottom.className = 'hm-wish__bottom';

      var price = document.createElement('span');
      price.className = 'hm-wish__price';
      // priceCents bevorzugen: formatiert immer mit dem AKTUELLEN Shop-Geldformat;
      // der gesnapshottete String (it.price) ist nur Fallback für Alt-Einträge ohne Cents.
      price.textContent = it.priceCents ? money(it.priceCents) : (it.price || '');
      bottom.appendChild(price);

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'hm-wish__add' + (inCart ? ' is-incart' : '');
      // Bereits im Cart → Button navigiert zum Cart-Drawer statt still nachzulegen.
      if (inCart) add.setAttribute('data-wish-show-cart', '');
      else if (it.variant) add.setAttribute('data-wish-add', it.variant);
      else add.disabled = true;
      add.setAttribute('aria-label', (inCart ? lab.inCart : lab.add) + ' · ' + (it.title || ''));
      add.innerHTML = inCart ? SVG.check : SVG.cart;
      add.appendChild(document.createTextNode(inCart ? lab.inCart : lab.add));
      bottom.appendChild(add);

      body.appendChild(bottom);
    }

    li.appendChild(body);
    return li;
  }

  /* ---------------- Fokus-Restore nach Neuaufbau (F018) ----------------
     renderDrawer() baut die Liste komplett neu auf — ein fokussierter Button im
     Drawer (Remove-X, Add) wird dabei zerstört, der Fokus fällt auf <body> und
     Tab liefe hinter das modale Dialog. Bei OFFENEM Drawer den Fokus ohne
     Scroll-Sprung zurückholen — geteilter Helfer H.overlay.restoreFocus(panel)
     (Close-Button, sonst Panel). */
  function restoreFocusIfOpen(panel) {
    if (!panel || !H.overlay || !H.overlay.isOpen || !H.overlay.isOpen(panel)) return;
    if (H.overlay.restoreFocus) H.overlay.restoreFocus(panel);
  }

  /* ---------------- Drawer rendern ---------------- */
  function renderDrawer(list) {
    var panel = document.getElementById(PANEL_ID);
    if (!panel) return;
    var host = panel.querySelector('[data-wishlist-lines]');
    if (!host) return;
    list = list || read();

    var empty = panel.querySelector('[data-wishlist-empty]');
    var foot = panel.querySelector('[data-wishlist-foot]');
    var subEl = panel.querySelector('[data-wishlist-subcount]');
    var totalEl = panel.querySelector('[data-wishlist-total]');
    var lab = labels(panel);
    var inCartSet = cartVariantSet();

    // Render-Reihenfolge: Produkte zuerst, dann Artikel-Bookmarks.
    var products = list.filter(function (it) { return it.type !== 'article'; });
    var articles = list.filter(function (it) { return it.type === 'article'; });

    host.textContent = '';
    if (!list.length) {
      host.hidden = true;
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
    } else {
      host.hidden = false;
      if (empty) empty.hidden = true;
      var frag = document.createDocumentFragment();
      products.forEach(function (it) {
        frag.appendChild(buildRow(it, lab, !!inCartSet[String(it.variant)]));
      });
      articles.forEach(function (it) { frag.appendChild(buildRow(it, lab, false)); });
      host.appendChild(frag);
      // Footer nur sinnvoll, wenn Produkte vorhanden (Gesamtwert + Alle-in-Warenkorb).
      if (foot) foot.hidden = products.length === 0;
    }

    // Untertitel-Label (Produkte · Artikel)
    if (subEl) {
      var parts = [];
      if (products.length) parts.push(products.length + ' ' + (products.length === 1 ? lab.productOne : lab.productMany));
      if (articles.length) parts.push(articles.length + ' ' + (articles.length === 1 ? lab.articleOne : lab.articleMany));
      subEl.textContent = parts.length ? parts.join(' · ') : lab.empty;
    }

    // Gesamtwert (Summe der Produkt-Cents)
    if (totalEl) {
      var sum = products.reduce(function (s, it) { return s + (it.priceCents || 0); }, 0);
      totalEl.textContent = money(sum);
    }

    restoreFocusIfOpen(panel); // F018: nur aktiv, wenn Drawer offen UND Fokus verloren ging
  }

  /* ---------------- Add-to-Cart aus dem Drawer ---------------- */
  function addToCart(variant, silent) {
    if (!variant || !(H.cart && H.cart.add)) return Promise.resolve();
    return H.cart.add({ id: variant, quantity: 1 }, { silent: silent === true })
      .then(function () { publish('homedia:wishlist_add_to_cart', { variant: variant }); })
      .catch(function () {});
  }

  function addAll() {
    var products = read().filter(function (it) { return it.type !== 'article' && it.variant; });
    if (!products.length || !(H.cart && H.cart.add)) return;
    var panel = document.getElementById(PANEL_ID);
    // Erst Warenkorb füllen; bei ERFOLG Merkliste schließen → Cart-Drawer übernimmt (cart:added).
    // Bei Fehler bleibt die Merkliste offen; cart.js meldet den Fehler via aria-live.
    H.cart.add({ items: products.map(function (it) { return { id: it.variant, quantity: 1 }; }) })
      .then(function () {
        publish('homedia:wishlist_add_all', { count: products.length });
        if (panel && H.overlay && H.overlay.isOpen(panel)) H.overlay.close(panel);
      })
      .catch(function () {});
  }

  /* ---------------- Öffnen ---------------- */
  function open(trigger) {
    var panel = document.getElementById(PANEL_ID);
    if (!panel || !H.overlay) return;
    renderDrawer();
    H.overlay.open(panel, { trigger: trigger || null, labelledby: 'hm-wish-title' });
    // Frischen Cart-State holen → In-Cart-Markierungen aktualisieren.
    if (H.cart && H.cart.get) H.cart.get().then(function () { renderDrawer(); }).catch(function () {});
  }

  /* ---------------- Delegierte Klicks ---------------- */
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest && e.target.closest('[data-wishlist-open]');
    if (openTrigger) { e.preventDefault(); open(openTrigger); return; }

    var addAllBtn = e.target.closest && e.target.closest('[data-wishlist-add-all]');
    if (addAllBtn) { e.preventDefault(); addAll(); return; }

    var addBtn = e.target.closest && e.target.closest('[data-wish-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var variant = addBtn.getAttribute('data-wish-add');
      addToCart(variant, true).then(function () { renderDrawer(); });
      return;
    }

    // „Im Warenkorb anzeigen": Merkliste schließen, Cart-Drawer im Listen-Modus öffnen.
    var showCartBtn = e.target.closest && e.target.closest('[data-wish-show-cart]');
    if (showCartBtn) {
      e.preventDefault();
      var wlPanel = document.getElementById(PANEL_ID);
      if (wlPanel && H.overlay && H.overlay.isOpen && H.overlay.isOpen(wlPanel)) H.overlay.close(wlPanel);
      if (H.cart && H.cart.open) H.cart.open();
      return;
    }

    var toggleBtn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) { e.preventDefault(); toggle(toggleBtn); return; }
  });

  // In-Cart-Markierungen aktualisieren, wenn der Cart sich ändert und der Drawer offen ist.
  document.addEventListener('cart:updated', function () {
    var panel = document.getElementById(PANEL_ID);
    if (panel && H.overlay && H.overlay.isOpen && H.overlay.isOpen(panel)) renderDrawer();
  });

  /* ---------------- Cross-Tab-Sync ---------------- */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { reflect(); renderDrawer(); }
  });

  /* ---------------- Public API ---------------- */
  H.wishlist = {
    read: read,
    count: function () { return read().length; },
    reflect: reflect,
    open: open,
    render: renderDrawer
  };

  /* ---------------- Init ---------------- */
  function init() { reflect(); renderDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
